import * as React from 'react';
import AffiliatedEntitiesCore from '../AfrCore/AffiliatedEntitiesCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';

const AffiliatedEntitiesA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <AffiliatedEntitiesCore userRole={isAdminUser ? "ADMIN" : "USER"} />
        </React.Fragment>
    );
}

export default AffiliatedEntitiesA;